<template>
  <div class="applicant-table">
    <entry-history-dialog ref="entryHistoryDialog"></entry-history-dialog>
    <duplicate-entry-dialog ref="duplicateEntryDialog"></duplicate-entry-dialog>
    <el-table class="mb-x2" :data="applicants" stripe @header-click="headerClick" empty-text=" " style="width: 100%">
      <el-table-column label="アカウント" sort-by="name" :render-header="renderHeader" min-width="14%">
        <template slot-scope="scope">
          <div class="pointer" data-drawer-not-close @click="openApplicantDrawer(scope.row.id, 'profile', 'account')">
            <applicant-name :applicant="scope.row" disabled-link screen="応募一覧（X）"></applicant-name>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="応募日時/ポスト内容"
        sort-by="publishDatetime"
        :render-header="renderHeader"
        min-width="20%"
      >
        <template slot-scope="scope">
          <div layout layout-align="space-between">
            <div class="message-date" layout="column">
              <div class="publishDatetime" layout layout-align="start-center">
                <el-tooltip
                  :enterable="false"
                  v-if="scope.row.post.postType === 'mention'"
                  placement="top"
                  content="メンション"
                  ><img class="icon" src="@/client/assets/images/icon_mention.svg"
                /></el-tooltip>
                <el-tooltip
                  :enterable="false"
                  v-if="scope.row.post.postType === 'retweet'"
                  placement="top"
                  content="リポスト"
                  ><img class="icon" src="@/client/assets/images/icon_retweet.svg"
                /></el-tooltip>
                <el-tooltip
                  :enterable="false"
                  v-if="scope.row.post.postType === 'quote_tweet'"
                  placement="top"
                  content="引用"
                  ><img class="icon" src="@/client/assets/images/icon_quote_tweet.svg" /></el-tooltip
                ><span>{{ formatDatetime(scope.row.post.publishDatetime) }}</span>
              </div>
              <div class="message-body" v-html="tweetText(scope.row.post.message)" @click="handleHashtagClick"></div>
            </div>
            <div class="post-image" v-if="scope.row.post.mediaUrl">
              <el-tooltip :enterable="false" popper-class="image-zoom-tootip" placement="right">
                <div slot="content"><img :src="scope.row.post.mediaUrl" /></div>
                <img :src="scope.row.post.mediaUrl" />
              </el-tooltip>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="フォロワー" sort-by="-followersCount" :render-header="renderHeader" min-width="10%">
        <template slot-scope="scope">
          <div>{{ formatNumber(scope.row.followersCount) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="FF比率" sort-by="-followsRate" :render-header="renderHeader" min-width="9%">
        <template slot-scope="scope">
          <div v-if="scope.row.followsRate === null">-</div>
          <div v-else>{{ formatNumber(scope.row.followsRate) }}{{ '%' }}</div>
        </template>
      </el-table-column>
      <el-table-column label="ポスト" sort-by="-tweetsCount" :render-header="renderHeader" min-width="9%">
        <template slot-scope="scope">
          <div>{{ formatNumber(scope.row.tweetsCount) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="応募数" sort-by="-postCount" :render-header="renderHeader" min-width="9%">
        <template slot-scope="scope"
          ><span class="clickable" @click="openApplicantDrawer(scope.row.id, 'profile')" data-drawer-not-close>{{
            formatNumber(scope.row.postsCount)
          }}</span></template
        >
      </el-table-column>
      <el-table-column
        label="累計参加数"
        sort-by="-totalCampaignEntryCount"
        :render-header="renderHeader"
        min-width="10%"
      >
        <template slot-scope="scope"
          ><span
            class="clickable"
            data-drawer-not-close
            v-if="campaignAccountId"
            @click="openApplicantDrawer(scope.row.id, 'entryHistory')"
            >{{ formatNumber(scope.row.totalCampaignEntryCount) }}</span
          ><span v-else>{{ formatNumber(scope.row.totalCampaignEntryCount) }}</span></template
        >
      </el-table-column>
      <el-table-column
        label="累計当選数"
        sort-by="-totalCampaignWinningCount"
        :render-header="renderHeader"
        min-width="10%"
      >
        <template slot-scope="scope"
          ><span
            class="clickable"
            data-drawer-not-close
            v-if="campaignAccountId"
            @click="openApplicantDrawer(scope.row.id, 'winHistory')"
            >{{ formatNumber(scope.row.totalCampaignWinningCount) }}</span
          ><span v-else>{{ formatNumber(scope.row.totalCampaignWinningCount) }}</span></template
        >
      </el-table-column>
      <el-table-column min-width="13%">
        <template slot-scope="scope">
          <div class="action-button" layout>
            <!-- 候補者フラグ-->
            <el-tooltip
              :enterable="false"
              v-if="scope.row.isNg === 1 && scope.row.isCandidate === 0"
              placement="top"
              content="NGアカウント"
            >
              <div>
                <el-button class="el-button--icon" type="default" :disabled="true"
                  ><i class="mdi mdi-star"></i
                ></el-button>
              </div>
            </el-tooltip>
            <el-tooltip
              :enterable="false"
              v-else-if="scope.row.isNg === 1 && scope.row.isCandidate === 1"
              placement="top"
              content="候補者を解除"
            >
              <div>
                <el-button
                  class="el-button--icon"
                  type="primary"
                  @click="updateFlag(scope.row.id, scope.row.isCandidate, 'candidate')"
                  :disabled="contractStatus === 3"
                  ><i class="mdi mdi-star"></i
                ></el-button>
              </div>
            </el-tooltip>
            <el-tooltip
              :enterable="false"
              v-else-if="scope.row.isCandidate === 1"
              placement="top"
              content="候補者を解除"
            >
              <div>
                <el-button
                  class="el-button--icon"
                  type="primary"
                  @click="updateFlag(scope.row.id, scope.row.isCandidate, 'candidate')"
                  :disabled="contractStatus === 3"
                  ><i class="mdi mdi-star"></i
                ></el-button>
              </div>
            </el-tooltip>
            <el-tooltip :enterable="false" v-else placement="top" content="候補者に追加">
              <div>
                <el-button
                  class="is-responder-button el-button--icon"
                  type="default"
                  @click="updateFlag(scope.row.id, scope.row.isCandidate, 'candidate')"
                  :disabled="contractStatus === 3"
                  ><i class="mdi mdi-star"></i
                ></el-button>
              </div>
            </el-tooltip>
            <!-- 当選者フラグ-->
            <el-tooltip
              :enterable="false"
              v-if="scope.row.isNg === 1 && scope.row.isWinner === 0"
              placement="top"
              content="NGアカウント"
            >
              <div>
                <el-button class="is-winner-button el-button--icon" type="default" :disabled="true"
                  ><i class="mdi mdi-trophy"></i
                ></el-button>
              </div>
            </el-tooltip>
            <el-tooltip
              :enterable="false"
              v-else-if="scope.row.isNg === 1 && scope.row.isWinner === 1"
              placement="top"
              :content="winnerTooltipContent('当選者を解除')"
            >
              <div>
                <el-button
                  class="is-winner-button el-button--icon"
                  type="primary"
                  @click="updateFlag(scope.row.id, scope.row.isWinner, 'winner')"
                  :disabled="isDmSending"
                  ><i class="mdi mdi-trophy"></i
                ></el-button>
              </div>
            </el-tooltip>
            <el-tooltip
              :enterable="false"
              v-else-if="scope.row.isWinner === 1"
              placement="top"
              :content="winnerTooltipContent('当選者を解除')"
            >
              <div>
                <el-button
                  class="is-winner-button el-button--icon"
                  type="primary"
                  @click="updateFlag(scope.row.id, scope.row.isWinner, 'winner')"
                  :disabled="contractStatus === 3 || isDmSending"
                  ><i class="mdi mdi-trophy"></i
                ></el-button>
              </div>
            </el-tooltip>
            <el-tooltip :enterable="false" v-else placement="top" :content="winnerTooltipContent('当選者に追加')">
              <div>
                <el-button
                  class="is-winner-button el-button--icon"
                  type="default"
                  @click="updateFlag(scope.row.id, scope.row.isWinner, 'winner')"
                  :disabled="contractStatus === 3 || isDmSending"
                  ><i class="mdi mdi-trophy"></i
                ></el-button>
              </div>
            </el-tooltip>
            <!-- 回答者フラグ-->
            <el-tooltip
              :enterable="false"
              v-if="scope.row.isNg === 1 && scope.row.isResponder === 0"
              placement="top"
              content="NGアカウント"
            >
              <div>
                <el-button class="is-responder-button el-button--icon" type="default" :disabled="true"
                  ><i class="mdi mdi-clipboard-check"></i
                ></el-button>
              </div>
            </el-tooltip>
            <el-tooltip
              :enterable="false"
              v-else-if="scope.row.isNg === 1 && scope.row.isResponder === 1"
              placement="top"
              content="回答者を解除"
            >
              <div>
                <el-button
                  class="is-responder-button el-button--icon"
                  type="primary"
                  @click="updateFlag(scope.row.id, scope.row.isResponder, 'responder')"
                  :disabled="contractStatus === 3"
                  ><i class="mdi mdi-clipboard-check"></i
                ></el-button>
              </div>
            </el-tooltip>
            <el-tooltip
              :enterable="false"
              v-else-if="scope.row.isResponder === 1"
              placement="top"
              content="回答者を解除"
            >
              <div>
                <el-button
                  class="is-responder-button el-button--icon"
                  type="primary"
                  @click="updateFlag(scope.row.id, scope.row.isResponder, 'responder')"
                  :disabled="contractStatus === 3"
                  ><i class="mdi mdi-clipboard-check"></i
                ></el-button>
              </div>
            </el-tooltip>
            <el-tooltip :enterable="false" v-else placement="top" content="回答者に追加">
              <div>
                <el-button
                  class="is-responder-button el-button--icon"
                  type="default"
                  @click="updateFlag(scope.row.id, scope.row.isResponder, 'responder')"
                  :disabled="contractStatus === 3"
                  ><i class="mdi mdi-clipboard-check"></i
                ></el-button>
              </div>
            </el-tooltip>
          </div>
          <div class="action-button mt-x1" layout>
            <!-- Twitterで確認-->
            <el-tooltip :enterable="false" placement="top" content="Xで確認">
              <template v-if="scope.row.post.postType === 'retweet'"
                ><a :href="'https://x.com/' + scope.row.screenName" target="_new" @click="clickTwitterConfirmation">
                  <el-button class="el-button--icon" type="default"><i class="mdi mdi-open-in-new"></i></el-button></a
              ></template>
              <template v-else
                ><a
                  :href="'https://x.com/' + scope.row.accountId + '/status/' + scope.row.post.id"
                  target="_new"
                  @click="clickTwitterConfirmation"
                >
                  <el-button class="el-button--icon" type="default"><i class="mdi mdi-open-in-new"></i></el-button></a
              ></template>
            </el-tooltip>
            <!-- メッセージ履歴-->
            <el-tooltip :enterable="false" placement="top" :content="'メッセージ履歴'">
              <div>
                <el-button
                  class="message-button el-button--icon"
                  data-drawer-not-close
                  type="default"
                  :disabled="scope.row.messagesCount <= 0"
                  @click="openApplicantDrawer(scope.row.id, 'streamHistory')"
                  ><i class="mdi mdi-message-text"></i>
                  <div class="badge badge-active" v-if="scope.row.messagesCount > 0">
                    {{ formatNumber(scope.row.messagesCount) }}
                  </div>
                </el-button>
              </div>
            </el-tooltip>
            <!-- NG追加/解除ボタン -->
            <a @click="changeNg(scope.row)">
              <el-tooltip :enterable="false" placement="top" :content="ngTooltipContent(scope.row)">
                <div>
                  <el-button
                    class="is-primary-button el-button--icon"
                    :type="scope.row.isNg === 1 ? 'primary' : 'default'"
                    ><i class="mdi mdi-cancel"></i
                  ></el-button>
                </div>
              </el-tooltip>
            </a>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div layout layout-align="space-between-center">
      <pagination
        flex="1"
        type="応募一覧（X）"
        :total="options.total"
        :pagingNo="options.pagingNo"
        :limitCount="options.limitCount"
        :onChangePagingNo="onChangePagingNo"
        :onChangeLimitCount="onChangeLimitCount"
      >
      </pagination>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.message-date {
  width: 100%;
  font-size: $font-small-size;
  line-height: 18px;

  .publishDatetime {
    color: $sub-text-color;
  }

  .message-body {
    max-height: 18px * 2;
    overflow-y: auto;
    white-space: pre-wrap;
  }

  .icon {
    width: 12px;
    height: 12px;
    margin-right: $spacing-unit;
  }
}

.post-image {
  margin-left: $spacing-unit;

  img {
    max-width: $spacing-unit * 10;
    max-height: $spacing-unit * 7;
  }
}

.last-processe-datetime {
  color: $sub-text-color;
  white-space: nowrap;
}

.badge {
  right: -4px;
  bottom: 0;
}

.clickable {
  color: $info-color;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.pointer {
  cursor: pointer;
}

.is-winner-button:focus,
.is-responder-button:focus {
  color: $text-color;
  background: #fff;
  border: 1px solid $border-color;
}

.is-winner-button.el-button--primary:focus,
.is-responder-button.el-button--primary:focus {
  color: #fff;
  background-color: $primary-color;
  border-color: $primary-color;
}

.message-button {
  position: relative;
}

.sub-value {
  font-size: $font-small-size;
  color: $sub-text-color;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.action-button {
  gap: $spacing-unit;

  .el-button {
    height: 40px;
  }

  .mdi {
    width: 20px;
    height: 20px;
    font-size: 20px;
  }
}
</style>
<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import ApplicantName from '@/client/components/_atoms/applicant_name'
import Icon from '@/client/components/_atoms/basic_icon'
import Pagination from '@/client/components/_atoms/pagination'
import Util from '@/client/core/util'
import DuplicateEntryDialog from '@/client/features/twitter_applicant/duplicate_entry_dialog'
import EntryHistoryDialog from '@/client/features/twitter_applicant/entry_history_dialog'
import { formatDatetime, formatNumber, formatTweetText } from '@/client/filters/filters'
import { TrackingService } from '@/client/services'
import { useSystemStore } from '@/client/store/useSystemStore'
import { useTwitterApplicantStore } from '@/client/store/useTwitterApplicantStore'
import { TApplicant } from '@/typings/api/twitter_applicants.type'

export default defineComponent({
  props: {
    applicants: Array,
    options: Object,
    campaignAccountId: Number,
    campaignId: Number,
    campaignType: String,
    campaignStartDatetime: String
  },
  components: {
    Pagination,
    ApplicantName,
    Icon,
    EntryHistoryDialog,
    DuplicateEntryDialog
  },
  data() {
    return {
      isSubmit: false
    }
  },
  computed: {
    ...mapState(useSystemStore, {
      contractStatus: state => state.currentGroup.contractStatus
    }),
    ...mapState(useTwitterApplicantStore, ['isDmSending'])
  },
  methods: {
    formatDatetime,
    formatNumber,

    ...mapActions(useTwitterApplicantStore, ['fetchApplicants']),

    /**
     * 当選者フラグのツールチップコンテンツ
     */
    winnerTooltipContent(text: string) {
      if (this.isDmSending) return 'DM送信中のため変更できません'

      return text
    },

    /**
     * ポストテキストをフォーマット
     * @param {string} text
     * @return {string} フォーマットしたテキスト
     */
    tweetText(text: string): string {
      return formatTweetText(text)
    },

    /**
     * ヘッダーをクリックするとソートする
     * @param {*} column
     */
    headerClick(column: any) {
      switch (column.label) {
        case 'アカウント':
          TrackingService.sendEvent('sort:応募一覧（X）|アカウント')
          break
        case '応募日時/ポスト内容':
          TrackingService.sendEvent('sort:応募一覧（X）|応募日時/ポスト内容')
          break
        case 'フォロワー':
          TrackingService.sendEvent('sort:応募一覧（X）|フォロワー')
          break
        case 'FF比率':
          TrackingService.sendEvent('sort:応募一覧（X）|FF比率')
          break
        case 'ポスト':
          TrackingService.sendEvent('sort:応募一覧（X）|ポスト')
          break
        case '応募数':
          TrackingService.sendEvent('sort:応募一覧（X）|応募数')
          break
        case '累計参加数':
          TrackingService.sendEvent('sort:応募一覧（X）|累計参加数')
          break
        case '累計当選数':
          TrackingService.sendEvent('sort:応募一覧（X）|累計当選数')
          break
        default:
          break
      }

      if (!column.sortBy) {
        return
      }
      if (column.sortBy.indexOf('-') === 0) {
        if (this.options.sortBy === column.sortBy) {
          this.$emit('sorting', { sortBy: column.sortBy.substring(1) })
        } else {
          this.$emit('sorting', { sortBy: column.sortBy })
        }
      } else {
        if (this.options.sortBy === column.sortBy) {
          this.$emit('sorting', { sortBy: '-' + column.sortBy })
        } else {
          this.$emit('sorting', { sortBy: column.sortBy })
        }
      }

      this.fetchApplicants()
    },

    /**
     * ヘッダー描画
     * @param {*} createElement
     * @param {*} { column }
     */
    renderHeader(createElement: any, { column }: any) {
      return Util.renderHeader(createElement, column.label, Util.getSortClass(this.options.sortBy, column.sortBy))
    },

    /**
     * ページング変更イベント
     * @param {number} page
     */
    onChangePagingNo(page: number) {
      this.$emit('paging', { pagingNo: page })

      this.fetchApplicants()
    },

    /**
     * 表示件数変更イベント
     * @param {number} limit
     */
    onChangeLimitCount(limit: number) {
      this.$emit('paging', { pagingNo: 1, limitCount: limit })

      this.fetchApplicants()
    },

    /**
     * メッセージ配信履歴を開く
     * @param {number} applicantId
     */
    openMessageHistory(applicantId: number) {
      this.$emit('open_message_history', {
        applicantId
      })
    },

    /**
     * ドロワーを開く
     */
    openApplicantDrawer(applicantId: number, tab: string, text: string) {
      switch (tab) {
        case 'profile':
          TrackingService.sendEvent(`click:応募一覧（X）|${text === 'account' ? 'ユーザーID' : '応募数'}`)
          break
        case 'entryHistory':
          TrackingService.sendEvent('click:応募一覧（X）|累計参加数')
          break
        case 'winHistory':
          TrackingService.sendEvent('click:応募一覧（X）|累計当選数')
          break
        case 'streamHistory':
          TrackingService.sendEvent('click:応募一覧（X）|メッセージ履歴')
          break
        default:
          break
      }

      this.$emit('open_applicant_drawer', {
        applicantId,
        tab
      })
    },

    /**
     * フラグ変更処理
     * @param {number} applicantId
     * @param {number} value
     * @param {string} type
     */
    updateFlag(applicantId: number, value: number, type: string) {
      switch (type) {
        case 'candidate':
          TrackingService.sendEvent('click:応募一覧（X）|候補者に追加')
          break
        case 'winner':
          TrackingService.sendEvent('click:応募一覧（X）|当選者に追加')
          break
        case 'responder':
          TrackingService.sendEvent('click:応募一覧（X）|回答者に追加')
          break
        default:
          break
      }

      const payload = {
        type,
        value: {}
      }

      switch (type) {
        case 'winner':
          payload.value = {
            applicantId,
            isWinner: value === 0 ? 1 : 0,
            wasWinner: 1
          }
          break
        case 'responder':
          payload.value = {
            applicantId,
            isResponder: value === 0 ? 1 : 0
          }
          break
        case 'candidate':
          payload.value = {
            applicantId,
            isCandidate: value === 0 ? 1 : 0
          }
          break
      }
      this.$emit('change_flag', payload)
    },

    /**
     * エラーを表示
     * @params {string} title タイトル
     */
    showError(title: string) {
      this.$notify({
        title,
        customClass: 'danger',
        duration: 5000
      })
    },

    clickTwitterConfirmation() {
      TrackingService.sendEvent('click:応募一覧（X）|Xで確認')
    },

    handleHashtagClick() {
      TrackingService.sendEvent('click:応募一覧（X）|キーワード')
    },

    /**
     * NGアカウントのツールチップコンテンツ
     */
    ngTooltipContent(row: TApplicant) {
      return row.isNg === 1 ? 'NGアカウントを解除' : 'NGアカウントに追加'
    },

    /**
     * NGアカウント追加/解除
     */
    changeNg(row: TApplicant) {
      TrackingService.sendEvent('click:応募一覧（X）|NGアカウントに追加')
      this.$emit('change_ng', {
        screenName: row.screenName,
        isNg: row.isNg === 0,
        ngApplicantId: row.ngApplicantId ?? null
      })
    }
  }
})
</script>
